import { Button, Dropdown, Space } from "antd";

const items = [
  {
    key: "1",
    label: <a> Excluir </a>,
  },
];

export const ColumnsImportData = [
  {
    title: "Data",
    dataIndex: "createdAt",
    textWrap: "word-break",
    ellipsis: true,
  },
  {
    title: "Cliente",
    dataIndex: "clientName",
    textWrap: "word-break",
    ellipsis: true,
  },
  {
    title: "Registros",
    dataIndex: "amount",
    textWrap: "word-break",
    ellipsis: true,
  },
  {
    title: "Observação",
    dataIndex: "observation",
    textWrap: "word-break",
    ellipsis: true,
  },
  {
    title: "Ações",
    dataIndex: "action",
    render: (text, row) => {
      return (
        <Space size="middle">
          <a onClick={() => row.disable(row)} type="primary">
            Excluir
          </a>
        </Space>
      );
    },
  },
];

export const ColumnsImportDataCsv = [
  {
    label: "Data",
    key: "createdAt",
  },
  {
    label: "Cliente",
    key: "clientName",
  },
  {
    label: "Registros",
    key: "amount",
  },
];
